import api from ".";
import { IStudentGroup } from "../entryes/panel/Courses/GroupSettings/types";
import { IUploadRequest } from "../typings/IFile";
import http from "./client";
import { IGetStudentsQueryParams } from "./students";

async function create(course_id: string | number, name?: string) {
  const resp = await http.post('/api/student-group/save', {
    course_id, name
  });

  return resp.data.data
}

async function remove(params: { id: string | number, course_id: string | number }) {
  await http.post('/api/student-group/delete', undefined, {
    params: params
  });
}

async function update(group: IStudentGroup) {
  const resp = await http.post('/api/student-group/save', group);

  return resp.data
}

export interface IStudentsGroupsSortParams {
  sortBy?: 'name';
  order?: 'asc' | 'desc';
  withStudentsCount?: boolean;
}
interface IGetListParams {
  course_id?: string | number;
  page?: number;
  limit?: number;
  search?: string;

}
async function list(params: IGetListParams & IStudentsGroupsSortParams) {
  const resp = await http.get('/api/student-group/list', {
    params,
  });

  return resp.data
}

async function link(users: Array<number | string>, groupId: number | string) {
  const response = await http.post(`/api/student-group/link`, {
    users,
    groupId
  });
  return response.data;
}

async function unlink(users: Array<number | string>, groupId: number | string) {
  const response = await http.post(`/api/student-group/unlink`, {
    users,
    groupId
  });
  return response.data;
}

async function linkAll(sortParams: IGetStudentsQueryParams, groupId?: number | string) {
  const response = await http.post(`/api/student-group/link-all`, {
    groupId,
    filter: sortParams,
    course_id: sortParams.course_id,
  });
  return response.data;
}

async function unlinkAll(groupId?: number | string) {
  const response = await http.post(`/api/student-group/unlink-all`, {
    groupId
  });
  return response.data;
}

async function importFile(file: File): Promise<IUploadRequest> {
  return api.file.uploadTemp(file);
}


const studentGroups = {
  update, list, create, remove, link, unlink, linkAll, unlinkAll, importFile
};

export default studentGroups;